import { MvhColorsType } from '@app-src/types'

/**
 * injectCustomFont
 * @description injects a custom font into a stylesheet string being constructed
 * @param {Object} mvhColors - the mvhColors configuration containing the fonts
 * @param {String} stylesheet - the string of CSS commands being built-up with font information
 * @param {Array} details - the key to use to find the font in [0], and the name of the font in [1]
 * @return {String} - the stylesheet with this font added
 */
export const injectCustomFont = (mvhColors?: MvhColorsType | null) => (
  stylesheet: string,
  [key, style]: Array<string>
) => {
  const fontForId =
    Boolean(mvhColors) && (mvhColors as Record<string, string>)[key]
  if (fontForId) {
    return `${stylesheet}
      @font-face {
        font-family: "PC LeadForms Custom Font ${style}";
        src: url(${fontForId});
      }
    `
  }

  return stylesheet
}

/**
 * injectCustomFonts
 * @description injects all custom fonts into a stylesheet string being constructed
 * @return {String} - the stylesheet with all fonts added
 */
export const injectCustomFonts = (mvhColors?: MvhColorsType | null): string =>
  [
    ['regularFont', 'Normal'],
    ['boldFont', 'Bold'],
    ['italicFont', 'Italic'],
    ['boldItalicFont', 'Bold Italic']
  ].reduce(injectCustomFont(mvhColors), '')
